import React from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { arrayOf, bool, shape, string } from "prop-types";

import { useUIData } from "../../redux/hooks/uiHooks";
import { formatOpenHouses } from "../../utilities/formatOpenHouses";
import OpenHouseItemActivity from "../OpenHouseItemActivity";
import * as S from "./styled";

const OpenHousesList = ({ attendedOHs, isPastOH, listOfItems, removedOHs }) => {
  const {
    myRecentOpenHousesExpanded,
    myUpcomingOpenHousesExpanded
  } = useUIData();
  const showFull = isPastOH
    ? myRecentOpenHousesExpanded
    : myUpcomingOpenHousesExpanded;
  const shouldShowSection = array =>
    !array.every(item => removedOHs.includes(item.open_house.id));

  return (
    <S.Wrapper>
      {formatOpenHouses(listOfItems, showFull).map(listItem => (
        <S.SubList
          key={`open-house-card-list-${listItem.date}`}
          isRemoved={!shouldShowSection(listItem.my_open_house_items)}
        >
          <S.Title>
            {moment(listItem.my_open_house_items[0].open_house.starts_at)
              .tz("America/New_York")
              .format("dddd, MMM DD")}
          </S.Title>
          {listItem.my_open_house_items.map(openHouseItem => (
            <S.ItemWrapper
              key={`open-house-card-${openHouseItem.listing_id}-${openHouseItem.open_house.id}`}
              isRemoved={removedOHs.includes(openHouseItem.open_house.id)}
            >
              <OpenHouseItemActivity
                endsAt={openHouseItem.open_house.ends_at}
                hasAnswer={attendedOHs.some(
                  aoh => aoh.id === openHouseItem.open_house.id
                )}
                hideActions={
                  openHouseItem.attended !== null &&
                  !attendedOHs.some(
                    aoh => aoh.id === openHouseItem.open_house.id
                  )
                }
                id={openHouseItem.open_house.id}
                imageUrl={openHouseItem.listing_medium_image_uri}
                isCanceled={openHouseItem.oh_cancelled}
                isPastOH={isPastOH}
                isTimeChanged={openHouseItem.oh_time_changed}
                listingAddress={openHouseItem.listing_title_with_unit}
                listingId={openHouseItem.listing_id}
                listingLink={openHouseItem.listing_url}
                numberOfRegisteredUsers={3}
                openHouseData={{
                  listingAddress: openHouseItem.listing_title_with_unit,
                  listingLink: openHouseItem.listing_url,
                  time: {
                    startsAt: openHouseItem.open_house.starts_at,
                    endsAt: openHouseItem.open_house.ends_at
                  },
                  streamingUrl: null
                }}
                savedOHId={openHouseItem.saved_open_house_id}
                startsAt={openHouseItem.open_house.starts_at}
              />
            </S.ItemWrapper>
          ))}
        </S.SubList>
      ))}
    </S.Wrapper>
  );
};

const mapStateToProps = state => ({
  attendedOHs: state.open_houses.attendedOHs,
  removedOHs: state.open_houses.removedOHs
});

OpenHousesList.propTypes = {
  attendedOHs: arrayOf(shape({})),
  isPastOH: bool,
  listOfItems: arrayOf(shape({})),
  removedOHs: arrayOf(string)
};

OpenHousesList.defaultProps = {
  attendedOHs: [],
  isPastOH: false,
  listOfItems: [],
  removedOHs: []
};

export default connect(mapStateToProps)(OpenHousesList);
